/* src/app/views/sales-channel/sales-channel.component.scss */
.container {
  --surface-soft: #ffffff;
  --surface-strong: #ffffff;
  --border-subtle: #d7e1f2;
  --text-primary: #17233a;
  --text-muted: #5d6d86;
  --action-primary: #046cea;
  --action-primary-hover: #0353b8;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #dbe4f0;
  border-radius: 16px;
  box-shadow: 0 18px 40px rgba(18, 38, 63, 0.1);
  overflow: hidden;
}
.container-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 32px 42px 8px 42px;
}
.title {
  font-weight: 400;
  font-size: clamp(24px, 4vw, 48px);
  line-height: 1.08;
  color: #14345f;
  margin: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.sales-channel-body {
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding: 16px 42px 30px 42px;
}
.sales-channel-shell {
  width: min(1020px, 100%);
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(290px, 360px) minmax(460px, 1fr);
  gap: 26px;
  align-items: stretch;
}
.channel-card,
.channel-form-card {
  border-radius: 18px;
  padding: 26px;
  box-sizing: border-box;
}
.channel-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 22px;
  background: #ffffff;
  border: 1px solid var(--border-subtle);
  box-shadow: 0 12px 28px rgba(24, 49, 86, 0.08);
  position: relative;
  overflow: hidden;
}
.channel-card::before {
  content: none;
  position: absolute;
  inset: auto -40px -60px auto;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
}
.channel-visual {
  width: 100%;
  min-height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7faff;
  backdrop-filter: blur(4px);
  border: 1px solid #dbe4f0;
  border-radius: 16px;
  padding: 22px;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
}
.image {
  width: min(220px, 60vw);
  height: auto;
  margin: 0;
  filter: drop-shadow(0 10px 16px rgba(8, 24, 56, 0.18));
}
.channel-badge {
  font-size: 22px;
  font-weight: 600;
  line-height: 1.2;
  color: var(--text-primary);
  text-align: center;
  letter-spacing: 0.02em;
  position: relative;
  z-index: 1;
}
.channel-form-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 22px;
  background: #ffffff;
  border: 1px solid var(--border-subtle);
  box-shadow: 0 12px 28px rgba(24, 49, 86, 0.08);
}
.chassi-label {
  display: block;
  width: min(500px, 100%);
  font-size: clamp(20px, 3.5vw, 34px);
  line-height: 1.25;
  font-weight: 400;
  color: var(--text-primary);
  margin: 0;
  max-width: 100%;
  word-wrap: normal;
  overflow-wrap: normal;
  word-break: normal;
  hyphens: none;
}
.chassi-input-row {
  width: min(500px, 100%);
}
.chassi-input {
  width: 100%;
  height: 60px;
  border: 1px solid #b8cae4;
  border-radius: 16px;
  padding: 0 18px;
  font-size: 18px;
  font-weight: 600;
  color: #23304a;
  box-sizing: border-box;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  background: #ffffff;
}
.chassi-input:focus {
  border-color: #5d8fd4;
  box-shadow: 0 0 0 4px rgba(93, 143, 212, 0.16);
  outline: none;
}
.margin-top-5,
.chassi-margin-top {
  margin-top: 0;
}
.button-position {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 22px 10px 0 10px;
  border-top: 1px solid #d8e2ee;
  box-sizing: border-box;
}
.action-button {
  width: 172px;
  height: 50px;
  background: var(--action-primary);
  border: 1px solid var(--action-primary);
  border-radius: 14px;
  margin-top: 0;
  margin-right: 0;
  box-shadow: 0 10px 18px rgba(4, 108, 234, 0.18);
}
.action-button-label {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
}
.action-button:disabled {
  background-color: #e5e5e5;
  cursor: not-allowed;
  border: 1px solid #aaaaaa;
  opacity: 0.75;
  box-shadow: none;
}
.action-button:disabled .action-button-label {
  color: #202020;
}
.action-button:hover:not(:disabled) {
  background: var(--action-primary-hover);
}
.action-button:disabled:hover {
  background-color: #e5e5e5;
  color: #202020;
  cursor: not-allowed;
  border: 1px solid #aaaaaa;
}
.action-button:disabled:hover .action-button-label {
  color: #202020;
}
.action-button.button-success {
  position: relative;
  box-shadow: 0 4px 20px rgba(12, 142, 28, 0.3);
  border-color: #0c8e1c;
}
.success-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  font-size: 20px;
  font-weight: bold;
  color: #0c8e1c;
  animation: pulse 1.5s infinite, scale-in 0.5s ease-out;
}
@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.1);
  }
}
@keyframes scale-in {
  from {
    opacity: 0;
    transform: scale(0.5);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes shake-gently {
  0%, 100% {
    transform: translateX(0) translateY(0);
  }
  25% {
    transform: translateX(-4px) translateY(-2px);
  }
  50% {
    transform: translateX(4px) translateY(2px);
  }
  75% {
    transform: translateX(-2px) translateY(-1px);
  }
}
.action-button:focus {
  outline: 2px solid var(--action-primary);
  outline-offset: 2px;
}
@media (max-width: 960px) {
  .container-header {
    padding: 20px 22px 10px 22px;
  }
  .title {
    font-size: 34px;
    line-height: 1.15;
  }
  .sales-channel-body {
    padding: 8px 22px 24px 22px;
  }
  .sales-channel-shell {
    grid-template-columns: 1fr;
    width: min(680px, 100%);
  }
  .chassi-label {
    font-size: 28px;
    width: min(500px, 100%);
    max-width: 100%;
  }
}
@media (max-width: 640px) {
  .container-header {
    padding: 16px 14px 8px 14px;
  }
  .title {
    font-size: 24px;
  }
  .sales-channel-body {
    padding: 6px 14px 18px 14px;
    gap: 18px;
  }
  .channel-card,
  .channel-form-card {
    padding: 16px;
  }
  .channel-visual {
    min-height: 200px;
  }
  .image {
    width: min(170px, 58vw);
  }
  .channel-badge {
    font-size: 18px;
  }
  .chassi-label {
    font-size: 24px;
    width: 100%;
  }
  .chassi-input {
    height: 52px;
    padding: 0 14px;
    font-size: 16px;
  }
  .button-position {
    padding: 16px 0 0 0;
  }
  .action-button {
    width: 100%;
    box-shadow: none;
  }
}
/*# sourceMappingURL=sales-channel.component-56A2OA5F.css.map */
